import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Button } from 'anf-core-react';
import { TmntText } from '../Common';
import { ERROR_MESSAGE } from '../Messages/Messages';
import { GIFT_CARD_PURCHASE_QUERY } from './operations';

export default function GiftCardPurchase({ userCountry }) {
  const { loading, error: queryError, data: queryData } = useQuery(GIFT_CARD_PURCHASE_QUERY);

  if (loading) return null;
  if (queryError) return ERROR_MESSAGE;

  const renderBuyGiftCardButton = () => {
    const displyGiftCardButton = userCountry === 'US' || userCountry === 'CA';

    if (!displyGiftCardButton) return null;
    return (
      <>
        <h1>
          <TmntText tmnt={queryData.textFor.buyGiftCardTitle} />
        </h1>
        <Button variant="tertiary-dark" href={queryData.config.buyGiftCardUrl}>
          <TmntText tmnt={queryData.textFor.buyGiftCardButtonText} />
        </Button>
      </>
    );
  };

  return (
    <div className="buy-gift-card-button" data-testid="buy-gift-card-button">
      {renderBuyGiftCardButton()}
    </div>
  );
}

GiftCardPurchase.propTypes = {
  userCountry: PropTypes.string,
};

GiftCardPurchase.defaultProps = {
  userCountry: '',
};
